import React from 'react';

import { flagStyles } from '../settings';

const SvgGL = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1944px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgGL;
